import * as React from 'react';

import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import TaxonomyLocationsPage from './Page';
import type { TaxonomyLocation } from '../../../types/uncinc_profile/taxonomy';

interface LocationProps {
  entity: ImmutableEntity<TaxonomyLocation>;
}

const TaxonomyLocationsWrapper: React.FC<LocationProps> = ({ entity, ...props }) => (
  <TaxonomyLocationsPage entity={entity} {...props} />
);

export default TaxonomyLocationsWrapper;
